module.exports = __webpack_public_path__ + "static/media/8.6d6e601f.jpg";